export const CREDIT_CARD_TRANSACTION_LIMIT = 5000;

const FEE_SCHEDULE = {
    credit_card: { fixed: 0.7, rate: 0.0315 },
    ach: { fixed: 1.8, rate: 0.0015 },
};

const roundCurrency = (value) =>
    Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export const calculateInvestorFees = (amount, paymentMethod) => {
    const investmentAmount = roundCurrency(amount);
    const schedule = FEE_SCHEDULE[paymentMethod];

    if(!schedule || !Number.isFinite(investmentAmount) || investmentAmount <= 0) {
        return null;
    }

    const processingFee = roundCurrency(
        schedule.fixed + investmentAmount * schedule.rate,
    );
    const platformFee = 1;
    const totalFees = roundCurrency(processingFee + platformFee);

    return {
        investmentAmount,
        processingFee,
        platformFee,
        totalFees,
        totalCharge: roundCurrency(investmentAmount + totalFees),
        processingFixedFee: schedule.fixed,
        processingRate: schedule.rate,
    };
};

export const formatCurrency = (value) =>
    Number(value).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
